<template>
    <div class="assetIndex">
        <totel asset="ture" class="totel"></totel>
        <div class="assetIndexBox">
          <assetsearch @assetSearch="searchTab"></assetsearch>
          <assettable :assettable="assetData"></assettable>
          <page
          v-on:clickPage="clickPage"
          :currentPage = "currentPage"
          :total = "assetCount"
          />
        </div>
    </div>
</template>
<script>
import totel from "@/components/TotelMoney";
import assetsearch from "@/components/AssetSearch";
import page from "../../components/PageIndex";
import assettable from "@/components/AssetTable";
import { mapGetters } from "vuex";
export default {
  components: { totel, assetsearch, assettable, page },
  data() {
    return {
      currentPage: 1,
      search: {
        status: -1,
        range: []
      }
    };
  },
  computed: {
    ...mapGetters([
      'assetCount',
      'assetTotal',
      'assetData'
    ])
  },
  created() {
    this._getList();
  },
  methods: {
    searchTab(val) {
      this.search = val;
      this._getList();
    },
    clickPage(val) {
      this.currentPage = val;
      this._getList();
    },
    _getList() {
      const { mchId } = this.$store.getters;
      let data = {
        status: this.search.status,
        start: this.search.range[0],
        end: this.search.range[1],
        page: this.currentPage,
        mchId
      };
      this.$store.dispatch("getAssetInfo", data);
    }
  }
};
</script>
<style lang="scss" scoped>
.assetIndex {
  height: 100%;
  padding-bottom: 50px;
}
.assetIndexBox {
  background-color: #fff;
  margin: 16px 16px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/AssetManagement/AssetIndex.vue